(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var getNative = require('../internal/getNative');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

module.exports = now;

},{"../internal/getNative":3}],2:[function(require,module,exports){
var isObject = require('../lang/isObject'),
    now = require('../date/now');

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it's invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

module.exports = debounce;

},{"../date/now":1,"../lang/isObject":7}],3:[function(require,module,exports){
var isNative = require('../lang/isNative');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;

},{"../lang/isNative":6}],4:[function(require,module,exports){
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],5:[function(require,module,exports){
var isObject = require('./isObject');

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

module.exports = isFunction;

},{"./isObject":7}],6:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isObjectLike = require('../internal/isObjectLike');

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isNative;

},{"../internal/isObjectLike":4,"./isFunction":5}],7:[function(require,module,exports){
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],8:[function(require,module,exports){
"use strict";

require("./modules/autofocus");

var angular = (window.angular);

var app = angular.module("app", ["ui.router", "ui.bootstrap", "utils.autofocus", "ngResource", "ngTable", "mgcrea.ngStrap.datepicker", "mgcrea.ngStrap.select", "mgcrea.ngStrap.button", "app.new"]);

module.exports = app;

},{"./modules/autofocus":31}],9:[function(require,module,exports){
"use strict";

module.exports = /*@ngInject*/function ($httpProvider) {
  $httpProvider.interceptors.push( /*@ngInject*/function ($q, $location, $window) {
    return {
      response: (function (_response) {
        var _responseWrapper = function response(_x) {
          return _response.apply(this, arguments);
        };

        _responseWrapper.toString = function () {
          return _response.toString();
        };

        return _responseWrapper;
      })(function (response) {
        if (response.status === 401) {
          console.log("Response 401");
        }
        return response || $q.when(response);
      }),
      responseError: function responseError(rejection) {
        if (rejection.status === 401) {
          console.log("Response Error 401", rejection);
          $window.location.href = "/auth/login?returnTo=#" + $location.path();
        }
        return $q.reject(rejection);
      }
    };
  });
};

},{}],10:[function(require,module,exports){
"use strict";

var app = require("../app");
var templateUrl = require("../helpers/templateUrl");
var angular = (window.angular);

app.factory("ChangesMigrationModal", ChangesMigrationModal);

// @ngInject
function ChangesMigrationModal($modal) {
  return function (modalOptions) {
    modalOptions = modalOptions || {};
    modalOptions = angular.isObject(modalOptions) ? modalOptions : { changeId: modalOptions };
    return $modal.open({
      templateUrl: templateUrl("changesMigrationModal"),
      controller: "ChangesMigrationModalController",
      controllerAs: "Modal",
      resolve: {
        modalOptions: (function (_modalOptions) {
          var _modalOptionsWrapper = function modalOptions() {
            return _modalOptions.apply(this, arguments);
          };

          _modalOptionsWrapper.toString = function () {
            return _modalOptions.toString();
          };

          return _modalOptionsWrapper;
        })(function () {
          return modalOptions;
        })
      }
    }).result;
  };
}

app.controller("ChangesMigrationModalController", ChangesMigrationModalController);

// @ngInject
function ChangesMigrationModalController($modalInstance, modalOptions, ServiceChanges, assetModal) {
  var _this = this;

  var changeId = modalOptions.changeId;

  if (changeId) {
    this.change = ServiceChanges.get({ id: changeId, _with: "assets.product" }, function (change) {
      change.assets.forEach(function (asset) {
        if (asset.pivot.role === "migratingFrom") {
          asset.name = asset.ref;
          _this.fromAsset = asset;
        }

        if (asset.pivot.role === "migratingTo") {
          asset.name = asset.ref;
          _this.toAsset = asset;
        }
      });
    });
  } else {
    this.change = new ServiceChanges();
    if (modalOptions.fromAsset) {
      this.fromAsset = modalOptions.fromAsset;
      this.fromAsset.name = this.fromAsset.ref;
    }
    this.change.type = "migrateProvider";
    this.change.state = 0;
  }

  this.newFromAsset = function () {
    assetModal().then(function (asset) {
      asset.name = asset.ref;
      _this.fromAsset = asset;
    });
  };

  this.newToAsset = function () {
    assetModal().then(function (asset) {
      asset.name = asset.ref;
      _this.toAsset = asset;
    });
  };

  // Save and close modal
  this.save = function () {
    updateResource();
    _this.change.$save().then(function (asset) {
      return $modalInstance.close(asset);
    });
  };

  var updateResource = function () {
    var assets = [];
    if (_this.fromAsset) {
      assets.push({
        role: "migratingFrom",
        id: _this.fromAsset.id
      });
    }

    if (_this.toAsset) {
      assets.push({
        role: "migratingTo",
        id: _this.toAsset.id
      });
    }

    _this.change.assets = assets;
  };
}

app.controller("AssetchangeMigrationController", AssetchangeMigrationController);
// @ngInject
function AssetchangeMigrationController($stateParams, Assets, ServiceChanges) {
  this.state = 0;

  this.fromAsset = $stateParams.fromAsset;
  this.toAsset = $stateParams.toAsset;

  this.save = function () {
    var assets = [];
    if (this.fromAsset) {
      assets.push({
        role: "migratingFrom",
        id: this.fromAsset.id
      });
    }

    if (this.toAsset) {
      assets.push({
        role: "migratingTo",
        id: this.toAsset.id
      });
    }

    var data = {
      type: "migrateProvider",
      state: this.state,
      date: this.getDate(),
      assets: assets
    };

    var change = new ServiceChanges(data);
    change.$save();
  };
}

},{"../app":8,"../helpers/templateUrl":29}],11:[function(require,module,exports){
"use strict";

var app = require("../app");
var angular = (window.angular);
var templateUrl = require("../helpers/templateUrl");

app.factory("assetModal", assetModal);

// @ngInject
function assetModal($modal, Assets, is) {
  return function (assetOptions) {

    return $modal.open({
      templateUrl: templateUrl("assetEditModal"),
      controller: "assetEditModalController",
      controllerAs: "Modal",
      resolve: {
        asset: (function (_asset) {
          var _assetWrapper = function asset() {
            return _asset.apply(this, arguments);
          };

          _assetWrapper.toString = function () {
            return _asset.toString();
          };

          return _assetWrapper;
        })(function () {
          if (is.id(assetOptions)) return Assets.get({ id: assetOptions, _with: "customer,product.supplier,site" }).$promise;

          var asset = new Assets();
          asset.state_id = 5;

          if (angular.isObject(assetOptions)) {
            angular.extend(asset, assetOptions);
          }

          return asset;
        })
      }
    }).result;
  };
}

app.controller("assetEditModalController", assetEditModalController);

// @ngInject
function assetEditModalController(Assets, customerModal, Sites, $modalInstance, asset) {
  var _this = this;

  this.siteList = [];
  // Hack, needs to be pulled from the database
  this.stateOptions = [{ id: 1, state: "live", is_live: 1 }, { id: 2, state: "pending upgrade", is_live: 1 }, { id: 3, state: "pending migration", is_live: 1 }, { id: 4, state: "pending cease", is_live: 1 }, { id: 5, state: "pending live", is_live: 0 }, { id: 6, state: "ceased", is_live: 0 }];

  this.onCustomerSelect = function (customer) {
    _this.updateSiteList(customer);
  };

  this.createCustomer = function () {
    var _this2 = this;

    customerModal().result.then(function (customer) {
      _this2.customer = customer;
    });
  };

  this.updateSiteList = function (customer) {
    _this.site = null;
    if (!customer) {
      return _this.siteList = [];
    }

    Sites.query({
      customer_id: customer.id
    }).$promise.then(function (results) {
      _this.siteList = results;
    });
  };

  this.save = function () {
    var asset = _this.asset;
    if (angular.isObject(_this.customer)) {
      asset.customer_id = _this.customer.id;
    }
    if (angular.isObject(_this.product)) {
      asset.product_id = _this.product.id;
    }
    if (angular.isObject(_this.site)) {
      asset.site_id = _this.site.id;
    }
    asset.meta = asset.meta || [];
    asset.$save().then(function () {
      $modalInstance.close(asset);
    })["catch"](function (error) {
      if (!error || error.status != 422) {
        return _this.errors = ["Unknown server error"];
      }

      var errors = [];
      angular.forEach(error.data, function (fieldErrors) {
        return errors = errors.concat(fieldErrors);
      });
      _this.errors = errors;
    });
  };

  this.init = function () {
    _this.asset = asset;

    if (asset.product) {
      _this.product = asset.product;
      _this.product.name = "" + asset.product.supplier.name + ": " + asset.product.name;
    }

    if (asset.customer) {
      _this.customer = asset.customer;
      _this.onCustomerSelect(asset.customer);
    }

    _this.site = asset.site;
  };
  this.init();
}

app.controller("AssetListController", AssetListController);

// @ngInject
function AssetListController(Assets, enTable, assetModal, $location) {
  var _this = this;

  var params = $location.search();
  var fixedParams = Object.keys(params).reduce(function (obj, key) {
    var newKey = key.replace(/\./g, "^");
    obj[newKey] = params[key];
    return obj;
  }, {});

  this.table = enTable(Assets, {
    query: angular.extend({
      _with: "customer,product.supplier,site"
    }, fixedParams)
  });

  this.create = function () {
    return assetModal().then(function () {
      return _this.table.reload();
    });
  };

  this.editModal = function (id) {
    return assetModal(id).then(function () {
      return _this.table.reload();
    });
  };
}

app.controller("AssetDetailController", AssetDetailController);

// @ngInject
function AssetDetailController($stateParams, ChangesMigrationModal, Assets, /*InvoiceItems, enTable, */assetModal, questionModal, $location, ServiceChangeHelper) {
  var _this = this;

  var assetId = $stateParams.assetId;

  var init = function () {
    _this.asset = Assets.get({ id: assetId, _with: "customer,product.supplier,servicechanges.assets,site" }).$promise.then(function (asset) {
      _this.asset = asset;
      _this.servicechanges = (asset.servicechanges || []).filter(function (change) {
        return change.state != "completed";
      });
      _this.canMigrate = _this.canCease = _this.servicechanges.length == 0 && asset.state.is_live;
    });
  };

  init();
  /*
    this.invoiceItemsTable = enTable(
      InvoiceItems,
      {
        query: {
          'asset_id' : assetId,
          '_with'    : 'invoice'
        }
      }
    )
  */

  this.showMigration = function (id) {
    ChangesMigrationModal(id).then(function () {
      return init();
    });
  };

  this.openEdit = function () {
    assetModal(assetId).then(function () {
      return init();
    });
  };

  this.startMigrationFrom = function (asset) {
    ServiceChangeHelper.startMigration({
      fromAssetId: asset.id
    });
  };

  this.startCease = function (asset) {
    ServiceChangeHelper.startCease({
      ceaseAssetId: asset.id
    });
  };

  this.startRegrade = function (asset) {
    ServiceChangeHelper.startRegrade({
      regradeAssetId: asset.id,
      previousProductId: asset.product_id
    });
  };

  this["delete"] = function () {
    return questionModal("Are you sure you want to delete '" + _this.asset.ref + "-" + _this.asset.product.name + "'?").then(function () {
      return _this.asset.$delete();
    }).then(function () {
      return $location.path("/assets");
    });
  };
}

},{"../app":8,"../helpers/templateUrl":29}],12:[function(require,module,exports){
"use strict";

var app = require("../app");
var templateUrl = require("../helpers/templateUrl");
var angular = (window.angular);

app.factory("customerModal", customerModal);

// @ngInject
function customerModal($modal) {
  return function (customerId) {
    return $modal.open({
      templateUrl: templateUrl("customerEditModal"),
      controller: "CustomerEditModalController",
      resolve: {
        customerId: (function (_customerId) {
          var _customerIdWrapper = function customerId() {
            return _customerId.apply(this, arguments);
          };

          _customerIdWrapper.toString = function () {
            return _customerId.toString();
          };

          return _customerIdWrapper;
        })(function () {
          return customerId;
        })
      }
    }).result;
  };
}

app.controller("CustomerListController", CustomerListController);

// @ngInject
function CustomerListController(Customers, enTable, customerModal) {
  var _this = this;

  this.table = enTable(Customers);

  this.create = function () {
    customerModal();
  };

  this.quickEdit = function (customerId) {
    customerModal(customerId).then(function () {
      return _this.table.reload();
    });
  };
}

app.controller("CustomerDetailController", CustomerDetailController);

// @ngInject
function CustomerDetailController($stateParams, Customers, Assets, Sites, enTable, customerModal, siteModal, assetModal, $state) {
  var _this = this;

  var customerId = this.id = $stateParams.customerId;

  var init = function () {
    Customers.get({
      id: customerId,
      _with: "assets.product.supplier"
    }, function (customer) {
      return _this.customer = customer;
    });

    _this.assetsTable = enTable(Assets, {
      query: {
        customer_id: customerId,
        _with: "product.supplier,site"
      }
    });

    _this.sitesTable = enTable(Sites, {
      query: { customer_id: customerId }
    });
  };
  init();

  this.editSite = function (id) {
    return siteModal(id).then(reload);
  };

  this.addSite = function () {
    return siteModal({ customer: _this.customer }).then(reload);
  };

  this.addAsset = function () {
    return assetModal({
      customer: _this.customer
    }).then(reload);
  };

  this.openEditModel = function () {
    customerModal(customerId).then(init);
  };

  function reload() {
    $state.go($state.current, {}, { reload: true });
  }
}

app.controller("CustomerEditModalController", CustomerEditModalController);

// @ngInject
function CustomerEditModalController($scope, $modalInstance, Customers, customerId) {

  $scope.customer = {
    id: customerId
  };

  if (customerId) {
    Customers.get({ id: customerId }, function (customer) {
      return $scope.customer = customer;
    });
  } else {
    $scope.customer = new Customers();
  }

  $scope.save = function () {
    $scope.customer.$save().then(function () {
      $modalInstance.close($scope.customer);
    }, function (err) {
      $scope.err = err;
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}

app.controller("CustomerCreateController", CustomerCreateController);

// @ngInject
function CustomerCreateController() {}

},{"../app":8,"../helpers/templateUrl":29}],13:[function(require,module,exports){
"use strict";

var app = require('./../app.js');
var angular = (window.angular);

//application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
var VAT = 0.2;

function floor(value, decimals) {
  return Number(Math.floor(value + "e" + decimals) + "e-" + decimals);
}

app.controller("InvoiceImportController", InvoiceImportController);

// @ng-inject
function InvoiceImportController(fileUpload) {
  var mv = this;

  mv["import"] = function () {
    fileUpload.uploadFileToUrl(mv.file, mv.invoice, "/invoices/import").success(function () {
      console.log("success");
    }).error(function () {
      console.log("error");
    });
  };

  mv.updateAmounts = function (net) {
    if (!isFinite(net)) {
      mv.invoice.vat = mv.invoice.gross = null;
      return;
    }

    mv.invoice.vat = floor(parseFloat(net) * VAT, 2);
    mv.invoice.gross = (parseFloat(mv.invoice.vat) + net).toFixed(2);
  };
}

app.controller("invoiceImportEasynetController", invoiceImportEasynetController);

// @ng-inject
function invoiceImportEasynetController(fileUpload) {
  var mv = this;

  mv.submit = function () {

    fileUpload.uploadFileToUrl(mv.file, "/invoices/storeEasynet").success(function () {
      console.log("success");
    }).error(function () {
      console.log("error");
    });
  };
}

app.controller("invoiceImportTimicoController", invoiceImportTimicoController);

// @ng-inject
function invoiceImportTimicoController(fileUpload) {
  var mv = this;

  mv.updateAmounts = function () {
    if (!isFinite(mv.netAmount)) {
      mv.vatAmount = mv.grossAmount = null;
      return;
    }
    mv.vatAmount = (mv.netAmount * VAT).toFixed(2);
    mv.grossAmount = (parseFloat(mv.vatAmount) + mv.netAmount).toFixed(2);
  };

  mv.submit = function () {
    mv.uploading = true;
    var data = {
      ref: mv.invoiceNumber,
      date: formatDate(mv.invoiceDate),
      net_amount: mv.netAmount,
      vat_amount: mv.vatAmount,
      gross_amount: mv.grossAmount,
      outstanding_amount: 0
    };
    fileUpload.uploadFileToUrl(mv.file, data, "/invoices/storeTimico").success(function () {
      mv.uploading = false;
      mv.messageState = "success";
      mv.message = "Invoice uploaded. You will be emailed when the import is complete.";
    }).error(function (err) {
      mv.uploading = false;
      mv.messageState = "danger";
      mv.message = "Upload Error." + angular.toJson(err);
      console.log("error");
    });
  };
}

function formatDate(date) {
  return "" + date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).substr(-2) + "-" + ("0" + date.getDate()).substr(-2);
}

app.controller("InvoiceListController", InvoiceListController);

// @ngInject
function InvoiceListController(Invoices, enTable) {
  this.table = enTable(Invoices, {
    query: {
      _with: "supplier"
    }
  });
}

},{"./../app.js":8}],14:[function(require,module,exports){
"use strict";

var app = require('./../app.js');

app.controller("navController", navController);
// @ngInject
function navController($http, $location) {
  var _this = this;

  this.$location = $location;

  $http.get("/getuser").then(function (res) {
    _this.user = res.data;
  });
}

},{"./../app.js":8}],15:[function(require,module,exports){
"use strict";

var app = require("../app");
var angular = (window.angular);

var forEach = angular.forEach;

app.controller("OverviewController", OverviewController);
// @ngInject
function OverviewController(Products, dotty, $http) {
  var _this = this;

  var get = dotty.get;
  var set = dotty.put;

  $http.get("api/serviceChanges/activeCount").then(function (results) {
    return _this.activeServiceChanges = results.data;
  });

  Products.query({
    _with: "assetsLiveCountRelation,supplier"
  }, function (results) {
    var productsByPath = arrangeByPath(results);
    _this.products = createDepthArray(createTotalsObject(productsByPath));
  });

  function createDepthArray(level) {
    var depth = arguments[1] === undefined ? 0 : arguments[1];

    var array = [];
    var product = {
      depth: depth,
      total: level.total,
      supplierTotals: level.supplierTotals,
      type: level.productType
    };
    if (depth === 0) {
      product.type = "Total";
    }
    array.push(product);

    if (angular.isArray(level.children) && level.children.length > 0) {
      forEach(level.children, function (child) {
        array = array.concat(createDepthArray(child, depth + 1));
      });
    } else {
      product.leaf = true;
    }

    return array;
  }

  function createTotalsObject(level, type) {
    var totalObj = {
      total: 0,
      supplierTotals: {}
    };

    if (type) {
      totalObj.productType = type;
    }

    if (angular.isArray(level)) {
      forEach(level, function (item) {
        var count = parseInt(get(item, "assets_live_count_relation.count"), 10) || 0;
        totalObj.total += count;
        var supplierName = get(item, "supplier.name");
        var supplierTotal = get(totalObj.supplierTotals, supplierName) || 0;
        set(totalObj.supplierTotals, supplierName, supplierTotal + count);
      });
    } else if (angular.isObject(level)) {
      var children = totalObj.children = [];
      forEach(level, function (subLevel, type) {
        var subTotals = createTotalsObject(subLevel, type);
        children.push(subTotals);
        totalObj.total += subTotals.total;

        forEach(subTotals.supplierTotals, function (count, supplier) {
          var currentTotal = get(totalObj.supplierTotals, supplier) || 0;
          set(totalObj.supplierTotals, supplier, currentTotal + count);
        });
      });
    }

    return totalObj;
  }

  function arrangeByPath(products) {
    var obj = {};

    forEach(products, function (product) {
      var path = product.path && product.path.split(",") || "Misc";
      var productPath = dotty.get(obj, path) || [];
      productPath.push(product);
      dotty.put(obj, path, productPath);
    });

    return obj;
  }
}

},{"../app":8}],16:[function(require,module,exports){
"use strict";

var app = require("../app");
var templateUrl = require("../helpers/templateUrl");

app.controller("ProductListController", ProductListController);
// @ngInject
function ProductListController(Products, enTable, $state) {

  this.table = enTable(Products, {
    query: {
      _with: "supplier,assetsCountRelation,type"
    }
  });

  this.create = function () {
    $state.go("productCreate");
  };
}

app.factory("productModal", productModalFactory);
// @ngInject
function productModalFactory($modal, Products) {
  return function (productId) {
    return $modal.open({
      templateUrl: templateUrl("productsEditModal"),
      controller: "productEditModalController",
      controllerAs: "Modal",
      resolve: {
        product: function product() {
          if (!productId) {
            return new Products();
          }return Products.get({ id: productId, _with: "supplier" }).$promise;
        }
      }
    }).result;
  };
}

app.controller("productEditModalController", productEditModalController);
// @ngInject
function productEditModalController(product, $modalInstance, questionModal) {
  this.product = product;

  this.save = function () {
    return product.$save().then(function () {
      return $modalInstance.close(product);
    });
  };
  this.cancel = function () {
    return $modalInstance.dismiss();
  };
}

},{"../app":8,"../helpers/templateUrl":29}],17:[function(require,module,exports){
"use strict";

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var debounce = require("lodash/function/debounce");
var app = require("../app");

app.controller("ServicechangeListController", ServicechangeListController);
// @ngInject
function ServicechangeListController(ServiceChanges, enTable, ChangesMigrationModal, $filter) {
  var _this = this;

  this.activate = function () {
    this.filter = {
      type: ["migrateProvider", "cease", "regrade", "deployment"],
      state: [0],
      dateOp: "--",
      date: $filter("date")(new Date(), "yyyy-MM-dd")
    };

    this.tableQuery = {
      query: this.queryify(this.filter)
    };

    this.table = enTable(ServiceChanges, this.tableQuery);
  };

  this.migrationEnum = {
    0: "Provisonal",
    1: "Confirmed",
    128: "Completed"
  };

  this.open = function (id) {
    ChangesMigrationModal(id).then(function () {
      return _this.table.reload();
    });
  };

  this.queryify = function (filter) {
    var query = {};
    var keys = ["type", "state"];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var valueArray = filter[key];
        if (valueArray.length == 0) {
          query[key] = -1;
          continue;
        }

        query[key] = valueArray.join(",");
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"]) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    switch (filter.dateOp) {
      case "on":
        query.date_primary = filter.date;
        break;
      case "before":
        query.date_primary = "lt:" + filter.date;
        break;
      case "after":
        query.date_primary = "gt:" + filter.date;
    }

    return query;
  };

  this.complete = function (serviceChange) {
    serviceChange.complete().then(function (data) {
      return angular.extend(serviceChange, data);
    });
  };

  this.updateFilter = function (filter) {
    _this.tableQuery.query = _this.queryify(filter);_this.reloadTable();
  };

  this.reloadTable = debounce(function () {
    return _this.table.reload();
  }, 500);

  this.activate();
}

app.controller("ServicechangeDetailController", ServicechangeDetailController);
// @ngInject
function ServicechangeDetailController($stateParams, ServiceChanges) {
  var _this = this;

  var changeId = $stateParams.changeId;
  var init = function () {
    ServiceChanges.get({
      id: changeId
    }, function (change) {
      _this.change = change;
    });
  };

  init();
}

var ServicechangeCreateController = function ServicechangeCreateController($stateParams) {
  "ngInject";

  _classCallCheck(this, ServicechangeCreateController);

  var options = $stateParams.options;
  var initState = this.initState = {};

  if (options) {
    initState.type = options.type;
    initState.assets = options.assets;
  }

  this.change = angular.extend({}, initState);
};

app.controller("ServicechangeCreateController", ServicechangeCreateController);

/*
($stateParams, $state, Assets, InvoiceItems, enTable, assetModal) {
  this.asset = {}
  var assetId = this.asset.id = $stateParams.assetId
 */

},{"../app":8,"lodash/function/debounce":2}],18:[function(require,module,exports){
"use strict";

var app = require("../app");

app.controller("sidebar", sidebar);

/*@nginject*/
function sidebar(navToggleState) {
  var mv = this;

  mv.navToggleState = navToggleState;
}

},{"../app":8}],19:[function(require,module,exports){
"use strict";

var app = require("../app");
var angular = (window.angular);
var templateUrl = require("../helpers/templateUrl");

app.factory("siteModal", siteModalFactory);
// @ngInject
function siteModalFactory($modal, Sites, is) {
  return function (siteOptions) {
    return $modal.open({
      templateUrl: templateUrl("siteEditModal"),
      controller: "siteEditModalController",
      controllerAs: "Modal",
      resolve: {
        site: (function (_site) {
          var _siteWrapper = function site() {
            return _site.apply(this, arguments);
          };

          _siteWrapper.toString = function () {
            return _site.toString();
          };

          return _siteWrapper;
        })(function () {
          if (is.id(siteOptions)) return Sites.get({ id: siteOptions, _with: "customer" }).$promise;

          var site = new Sites();
          if (angular.isObject(siteOptions)) {
            angular.extend(site, siteOptions);
          }
          return site;
        })
      }
    }).result;
  };
}

app.controller("siteEditModalController", siteEditModalController);
// @ngInject
function siteEditModalController($modalInstance, site, questionModal) {
  this.site = site;

  this.save = function () {
    return site.$save().then(function () {
      return $modalInstance.close(site);
    });
  };
  this.cancel = function () {
    return $modalInstance.dismiss();
  };

  this["delete"] = function () {
    return questionModal("Are you sure you want to delete site: " + site.name + "?").then(function () {
      return site.$delete();
    }).then(function () {
      return $modalInstance.close();
    });
  };
}

app.controller("SiteListController", siteListController);
// @ngInject
function siteListController(enTable, Sites, siteModal) {
  var _this = this;

  this.table = enTable(Sites, {
    query: {
      _with: "customer"
    }
  });

  this.create = function () {
    siteModal().then(function () {
      return _this.table.reload();
    });
  };

  this.edit = function (id) {
    siteModal(id).then(function () {
      return _this.table.reload();
    });
  };
}

},{"../app":8,"../helpers/templateUrl":29}],20:[function(require,module,exports){
"use strict";

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var app = require("../app");

// @ngInject
//function SupplierListController(Suppliers, ngTableParams) {
//

var SupplierListController = function SupplierListController(Suppliers, enTable) {
  _classCallCheck(this, SupplierListController);

  this.table = enTable(Suppliers);
};

app.controller("SupplierListController", SupplierListController);

module.exports = {

  /*@ngInject*/list: function list($http, suppliers, Customers) {
    var mv = this;

    window.Customers = Customers;

    mv.suppliers = suppliers;
  },

  /*@ngInject*/
  create: function create($http, $state) {
    var mv = this;
    mv.store = function () {
      $http.post("/suppliers", mv.supplier).success(function () {
        $state.go("suppliers.list");
      });
    };
  },

  /*@ngInject*/view: function view(supplier, $http, $state) {
    var mv = this;

    mv.supplier = supplier;

    mv.update = function () {
      $http.put("/suppliers/" + supplier.id, mv.supplier).success(function () {
        mv.state = "view";
      });
    };

    mv["delete"] = function () {
      $http["delete"]("/suppliers/" + supplier.id).success(function () {
        $state.go("suppliers.list");
      });
    };
  }
};

},{"../app":8}],21:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var app = require("../app.js");
var angular = (window.angular);

var AssetListController = (function () {
  function AssetListController(Assets, enTable, $scope) {
    "ngInject";

    _classCallCheck(this, AssetListController);

    angular.extend(this, { Assets: Assets, enTable: enTable, $scope: $scope });

    this.activate();
  }

  _createClass(AssetListController, {
    activate: {
      value: function activate() {
        var _this = this;

        this.filter = this.filter || {};
        this.hideColumns = this.hideColumns && this.hideColumns.split(",") || [];

        this.table = this.enTable(this.Assets, {
          query: angular.extend({
            _with: "customer,product.supplier,site"
          }, this.filter)
        });

        this.$scope.$watch("comp.filter", function (filter) {
          return _this.table.filter(filter);
        }, true);
      }
    },
    hideColumn: {
      value: function hideColumn(name) {
        return this.hideColumns.indexOf(name) !== -1;
      }
    }
  });

  return AssetListController;
})();

app.directive("assetList", function () {
  return {
    scope: {
      filter: "=",
      hideColumns: "@"
    },
    controller: AssetListController,
    controllerAs: "comp",
    bindToController: true,
    templateUrl: "/components/assets/list.html"
  };
});

},{"../app.js":8}],22:[function(require,module,exports){
"use strict";

var app = require("../app.js");
var angular = (window.angular);

app.directive("dateSelect", function () {
	return {
		restrict: "E",
		scope: {
			ngModel: "=",
			onChange: "&"
		},
		template: "<input\n\t\t\tng-model=\"ngModel\"\n\t\t\tis-open=\"isOpen\"\n\t\t\tng-click=\"isOpen = !isOpen\"\n\t\t\tdatepicker-popup=\"\"\n\t\t\tclass=\"form-control\"\n\t\t/>",
		link: function link(scope, el, attr) {
			var cachedDate;
			var $input = angular.element(el).find("input:first");
			angular.forEach(attr, function (value, key) {
				if (key.startsWith("$") || key === "ng-model") {
					return;
				}

				$input.attr(key, value);
				el.removeAttr(key);
			});
			el.removeAttr("ng-model");

			scope.$watch("ngModel", function (newDate) {
				newDate = dateToString(newDate);
				if (newDate !== cachedDate) {
					cachedDate = scope.ngModel = newDate;
					scope.onChange({ date: newDate });
				}
			});
		}
	};

	function dateToString(inDate) {
		if (!inDate) {
			return null;
		}
		var date = new Date(inDate);

		if (date.toDateString() == "Invalid Date") {
			return inDate;
		}return "" + date.getFullYear() + "-" + leadingZero(date.getMonth() + 1) + "-" + leadingZero(date.getDate());

		function leadingZero(number) {
			return number < 10 ? "0" + number : number;
		}
	}
});

},{"../app.js":8}],23:[function(require,module,exports){
"use strict";

var app = require('./../app.js');

app.value("navToggleState", { state: true });

app.directive("navToggle", function (navToggleState) {
  "ngInject";
  return {
    restrict: "A",
    link: function link(scope, element, attr) {
      element.on("click", toggle);

      function toggle() {
        scope.$apply(function () {

          navToggleState.state = !navToggleState.state;
        });
      }
    }
  };
});

},{"./../app.js":8}],24:[function(require,module,exports){
"use strict";

var app = require("../app");
var angular = (window.angular);
var templateUrl = require("../helpers/templateUrl");

var extend = angular.extend;

app.directive("searchSelect", function ($timeout) {
  return {
    restrict: "E",
    scope: {
      label: "=selectLabel",
      ngModel: "=",
      selectLookup: "=",
      placeholder: "@",
      selectOnChange: "=" },
    templateUrl: templateUrl("searchSelect"),
    link: function link(scope, el, attr) {
      var oldValue = scope.ngModel;

      scope.lookup = function (terms) {
        terms = terms.replace(":", "");
        return scope.selectLookup(terms);
      };

      scope.onBlur = function () {
        scope.ngModel = scope.ngModel || null;
        $timeout(scope.checkForChange, 200);
      };

      scope.onSelect = function ($item, $model, $label) {
        scope.checkForChange();
      };

      scope.checkForChange = function () {
        var oldId = angular.isObject(oldValue) ? oldValue.id : null;
        var newId = angular.isObject(scope.ngModel) ? scope.ngModel.id : null;
        if (oldId !== newId) {
          if (angular.isFunction(scope.selectOnChange)) {
            scope.selectOnChange(scope.ngModel);
          }
        }
        oldValue = scope.ngModel;
      };
    }
  };
});

app.value("lookupModel", function (model, opts) {
  opts = opts || {};

  var queryDefaults = opts.queryDefaults || {};

  return function (term) {
    var queryOpts = extend({ _q: term, _limit: 10 }, queryDefaults);

    if (typeof opts.getFilter == "function") {
      extend(queryOpts, opts.getFilter());
    }

    var promise = model.query(queryOpts).$promise;

    if (opts.resultMap) {
      promise = promise.then(function (results) {
        return results.map(opts.resultMap);
      });
    }

    return promise;
  };
});

app.directive("selectCustomers", function (Customers, lookupModel, customerModal) {
  return {
    restrict: "E",
    scope: {
      ngModel: "=",
      selectOnChange: "="
    },
    template: "<search-select\n          select-label=\"'Customer'\"\n          ng-model=\"ngModel\"\n          select-on-change=\"selectOnChange\"\n          select-lookup=\"lookup\"\n          placeholder=\"search customers\"\n       ></search-select>\n       <a href=\"#\" ng-click=\"createCustomer()\">Add Customer</a>\n       ",
    link: function link(scope, el, attr) {
      scope.lookup = lookupModel(Customers);

      scope.createCustomer = function () {
        customerModal().result.then(function (customer) {
          scope.ngModel = customer;
        });
      };
    }
  };
});

app.directive("selectAssets", function (Assets, lookupModel) {
  return {
    restrict: "E",
    scope: {
      ngModel: "=",
      selectOnChange: "=",
      onSelect: "&"
    },
    template: "<search-select\n          select-label=\"label\"\n          ng-model=\"ngModel\"\n          select-on-change=\"selectOnChange\"\n          select-lookup=\"lookup\"\n          placeholder=\"search assets\"\n       ></search-select>\n       ",
    link: function link(scope, el, attr) {
      scope.label = attr.label || "Asset";
      scope.lookup = lookupModel(Assets, {
        queryDefaults: { _with: "customer,product.supplier" },
        resultMap: function resultMap(asset) {
          var name = asset.ref;
          if (asset.customer) {
            name += " " + asset.customer.name;
          }
          if (asset.product) {
            name += " (" + asset.product.supplier.name + " " + asset.product.name + ")";
          }
          return { id: asset.id, name: name };
        }
      });
      scope.selectOnChange = function (asset) {
        scope.onSelect({ asset: asset });
      };
    }
  };
});

app.directive("selectProducts", function (Products, lookupModel) {
  return {
    restrict: "E",
    scope: {
      ngModel: "=",
      selectOnChange: "=",
      filter: "="
    },
    template: "<search-select\n          select-label=\"'Product'\"\n          ng-model=\"ngModel\"\n          select-on-change=\"selectOnChange\"\n          select-lookup=\"lookup\"\n          placeholder=\"search products\"\n       />",
    link: function link(scope, el, attr) {

      scope.lookup = lookupModel(Products, {
        queryDefaults: { _with: "supplier" },
        getFilter: function () {
          return scope.filter || {};
        },
        resultMap: function resultMap(product) {
          return {
            id: product.id,
            name: "" + product.supplier.name + ": " + product.name + "" + (product.market ? " Market: " + product.market : "")
          };
        }
      });
    }
  };
});

app.directive("selectSuppliers", function (Suppliers, lookupModel) {
  return {
    restrict: "E",
    scope: {
      ngModel: "=",
      selectOnChange: "="
    },
    template: "<search-select\n          select-label=\"label\"\n          ng-model=\"ngModel\"\n          select-on-change=\"selectOnChange\"\n          select-lookup=\"lookup\"\n          placeholder=\"search suppliers\"\n       ></search-select>\n       ",
    link: function link(scope, el, attr) {
      scope.label = attr.label || "Suppliers";
      scope.lookup = lookupModel(Suppliers);
    }
  };
});

},{"../app":8,"../helpers/templateUrl":29}],25:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var app = require("../app");
var angular = (window.angular);

var ServiceChangeCeaseCtrl = (function () {
	function ServiceChangeCeaseCtrl(ServiceChange) {
		"ngInject";

		_classCallCheck(this, ServiceChangeCeaseCtrl);

		this.ServiceChange = ServiceChange;

		this.activate();
	}

	_createClass(ServiceChangeCeaseCtrl, {
		activate: {
			value: function activate() {
				var _this = this;

				this.exists = !!this.change.id;

				if (this.exists) {
					this.change.canComplete().then(function (result) {
						_this.canComplete = result.passes;
						_this.canCompleteErrors = result.errors;
					});
				}

				if (angular.isObject(this.change)) {
					this.changeRecord = new this.ServiceChange();
					this.changeRecord.type = "cease";
					angular.extend(this.changeRecord, this.change);
				} else {
					this.changeRecord = this.ServiceChange.get({ id: this.change });
					this.changeRecord.canComplete().then(function (result) {
						_this.canComplete = result.success;
						_this.canCompleteErrors = result.errors;
					});
				}
			}
		},
		save: {
			value: function save() {
				var _this = this;

				var assets = [];
				for (var role in this.change.assets) {
					assets.push({ id: this.change.assets[role], role: role });
				}
				this.changeRecord.assets = assets;
				this.saving = true;
				this.changeRecord.$save().then(function () {
					_this.saving = false;
				});
			}
		},
		complete: {
			value: function complete() {
				var _this = this;

				this.change.complete().then(function () {
					_this.activate();
				});
			}
		}
	});

	return ServiceChangeCeaseCtrl;
})();

var template = "\n<h1>Cease<h1>\n<pre>{{mv.canComplete ? 'Can be Completed' : 'Cannot be completed'}}</pre>\n<pre>{{mv.canCompleteErrors}}</pre>\n<pre>{{mv.changeRecord | json}}</pre>\n<pre>{{mv.saving | json}}</pre>\n<a class=\"btn btn-primary\" href=\"\" role=\"button\" ng-click=\"mv.save()\">Save</a>\n<a ng-show=\"mv.canComplete\" class=\"btn btn-primary\" href=\"\" role=\"button\" ng-click=\"mv.complete()\">Complete</a>\n";

app.directive("serviceChangeCease", function () {
	return {
		restrict: "E",
		scope: {
			change: "="
		},
		controller: ServiceChangeCeaseCtrl,
		controllerAs: "mv",
		bindToController: true,
		template: template
	};
});

},{"../app":8}],26:[function(require,module,exports){
"use strict";

var app = require("../app");

app.filter("enDate", enDateFactory);
// @ngInject
function enDateFactory($filter) {
  return function (date, format, timezone) {
    if (date == null) {
      return "";
    }
    if (date instanceof Date) {
      return $filter("date")(date, format, timezone);
    }
    return $filter("date")(date.replace(" ", "T"), format, timezone);
  };
}

},{"../app":8}],27:[function(require,module,exports){
"use strict";

var app = require("../app");

app.filter("enum", function () {
	return function enumFilter(input, valueMap) {
		return valueMap[input] ? valueMap[input] : "";
	};
});

},{"../app":8}],28:[function(require,module,exports){
"use strict";

var app = require("../app");

app.filter("regularCase", function () {
  return function regularCase(input) {
    if (!input) {
      return "";
    }
    return input[0].toUpperCase() + input.substr(1).replace(/([a-z])([A-Z])/g, "$1 $2");
  };
});

},{"../app":8}],29:[function(require,module,exports){
"use strict";

function templateUrl(componentName) {
  return "/components/" + kebabcase(componentName) + "/" + kebabcase(componentName) + ".html";
}

function kebabcase(str) {
  return str.replace(/[A-Z]/g, function ($1) {
    return "-" + $1.toLowerCase();
  });
}

templateUrl.kebabcase = kebabcase;

module.exports = templateUrl;

},{}],30:[function(require,module,exports){
/// <reference path="../../../typings/node/node.d.ts" />
//require('babelify/polyfill')

"use strict";

var app = require("./app");
var concatenify = undefined;

app.config(require("./config/authInterceptor"));

require('./services/dotty.js');require('./services/enTable.js');require('./services/is.js');require('./services/questionModal.js');require('./services/resources.js');require('./services/upload.js');;
require('F:/inetpub/ensure.ev.net.uk/resources/client/services/ServiceChangeHelper.js');;
require('./directives/assetList.js');require('./directives/dateSelect.js');require('./directives/navToggle.js');require('./directives/searchSelect.js');require('./directives/servicechange-cease.js');;
require('F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-detail-mini.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-history-item.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-history.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-select.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/datePicker/datePicker.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/product/product-show-or-select.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/servicechange/servicechange-details.js');require('F:/inetpub/ensure.ev.net.uk/resources/client/components/servicechange/servicechange-filter.js');;
require('./controllers/assetchanges.js');require('./controllers/assets.js');require('./controllers/customers.js');require('./controllers/invoices.js');require('./controllers/navuser.js');require('./controllers/overview.js');require('./controllers/products.js');require('./controllers/serviceChanges.js');require('./controllers/sidebar.js');require('./controllers/sites.js');require('./controllers/suppliers.js');;
require('./filters/enDate.js');require('./filters/enum.js');require('./filters/regularCase.js');;

app.config(require("./routes"));

},{"./app":8,"./config/authInterceptor":9,"./controllers/assetchanges.js":10,"./controllers/assets.js":11,"./controllers/customers.js":12,"./controllers/invoices.js":13,"./controllers/navuser.js":14,"./controllers/overview.js":15,"./controllers/products.js":16,"./controllers/serviceChanges.js":17,"./controllers/sidebar.js":18,"./controllers/sites.js":19,"./controllers/suppliers.js":20,"./directives/assetList.js":21,"./directives/dateSelect.js":22,"./directives/navToggle.js":23,"./directives/searchSelect.js":24,"./directives/servicechange-cease.js":25,"./filters/enDate.js":26,"./filters/enum.js":27,"./filters/regularCase.js":28,"./routes":32,"./services/dotty.js":33,"./services/enTable.js":35,"./services/is.js":36,"./services/questionModal.js":37,"./services/resources.js":38,"./services/upload.js":39,"F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-detail-mini.js":40,"F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-history-item.js":41,"F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-history.js":42,"F:/inetpub/ensure.ev.net.uk/resources/client/components/asset/asset-select.js":43,"F:/inetpub/ensure.ev.net.uk/resources/client/components/datePicker/datePicker.js":44,"F:/inetpub/ensure.ev.net.uk/resources/client/components/product/product-show-or-select.js":45,"F:/inetpub/ensure.ev.net.uk/resources/client/components/servicechange/servicechange-details.js":46,"F:/inetpub/ensure.ev.net.uk/resources/client/components/servicechange/servicechange-filter.js":47,"F:/inetpub/ensure.ev.net.uk/resources/client/services/ServiceChangeHelper.js":49}],31:[function(require,module,exports){
"use strict";

var angular = (window.angular);

angular.module("utils.autofocus", []).directive("autofocus", ["$timeout", function ($timeout) {
  return {
    restrict: "A",
    link: function link($scope, $element) {
      $timeout(function () {
        $element[0].focus();
      });
    }
  };
}]);

},{}],32:[function(require,module,exports){
"use strict";

var getTemplateUrl = require("./helpers/templateUrl");

module.exports = routes;

function routes($stateProvider, $urlRouterProvider, $locationProvider) {
  "ngInject";
  //
  // For any unmatched url, redirect to /state1
  $urlRouterProvider.otherwise("/");
  //
  // Now set up the states
  //
  // $stateProvider
  //   .state({
  //     name: 'overview',
  //     url: '/',
  //     templateUrl: 'partials/overview.html'
  //   })

  var $router = routerBuilder($stateProvider, $urlRouterProvider);

  $router.config([{ path: "/", component: "overview" }, { path: "/customers", component: "customerList" }, { path: "/customers/create", component: "customerCreate" }, { path: "/customers/:customerId", component: "customerDetail" }, { path: "/sites", component: "siteList" }, { path: "/sites/create", component: "siteCreate" }, { path: "/sites/:siteId", component: "siteDetail" }, { path: "/suppliers", component: "supplierList" }, { path: "/suppliers/:supplierId", component: "supplierDetail" }, { path: "/products", component: "productList" }, { path: "/assets", component: "assetList" }, { path: "/assets/create", component: "assetCreate" }, { path: "/assets/:assetId", component: "assetDetail", as: "mv" }, { path: "/invoices", component: "invoiceList" }, { path: "/servicechange", component: "servicechangeList" }]);

  $stateProvider.state({
    name: "serviceChangeCreate",
    controller: function controller($stateParams) {
      "ngInject";
      this.serviceChange = $stateParams.options.serviceChange;
    },
    controllerAs: "mv",
    template: "<service-change-details service-change=\"mv.serviceChange\"></service-change-details>",
    params: { options: null }
  });

  $stateProvider.state({
    name: "serviceChangeDetails",
    url: "/servicechange/:servicechangeId",
    controller: function controller(serviceChange) {
      "ngInject";
      this.serviceChange = serviceChange;
    },
    controllerAs: "mv",
    resolve: {
      serviceChange: function serviceChange($stateParams, ServiceChanges) {
        "ngInject";
        return ServiceChanges.get({ id: $stateParams.servicechangeId }).$promise;
      }
    },
    template: "<service-change-details service-change=\"mv.serviceChange\"></service-change-details>"
  });
}

function routerBuilder($stateProvider, $urlRouterProvider) {
  "ngInject";
  return {
    config: config
  };

  function config(routeList) {
    routeList = angular.isArray(routeList) ? routeList : [routeList];
    angular.forEach(routeList, addRoute);
  }

  function addRoute(route) {
    var name = route.component;
    var controller = "" + capitialize(name) + "Controller";
    var controllerAs = route.as || name;
    var templateUrl = getTemplateUrl(name);
    var url = route.path;

    var state = {
      name: name,
      url: url,
      templateUrl: templateUrl,
      controller: controller,
      controllerAs: controllerAs
    };

    if (angular.isObject(route.options)) {
      angular.extend(state, route.options);
    }

    $stateProvider.state(state);
  }
}

function capitialize(str) {
  return str[0].toUpperCase() + str.substr(1);
}

function kebabcase(str) {
  return str.replace(/[A-Z]/g, function ($1) {
    return "-" + $1.toLowerCase();
  });
}

},{"./helpers/templateUrl":29}],33:[function(require,module,exports){
"use strict";

var app = require("../app");
var dotty = require("./dotty/index");

app.value("dotty", dotty);

},{"../app":8,"./dotty/index":34}],34:[function(require,module,exports){
//
// Dotty makes it easy to programmatically access arbitrarily nested objects and
// their properties.
//

//
// `object` is an object, `path` is the path to the property you want to check
// for existence of.
//
// `path` can be provided as either a `"string.separated.with.dots"` or as
// `["an", "array"]`.
//
// Returns `true` if the path can be completely resolved, `false` otherwise.
//

"use strict";

var exists = module.exports.exists = function exists(_x, _x2) {
  var _again = true;

  _function: while (_again) {
    _again = false;
    var object = _x,
        path = _x2;
    key = undefined;

    if (typeof path === "string") {
      path = path.split(".");
    }

    if (!(path instanceof Array) || path.length === 0) {
      return false;
    }

    path = path.slice();

    var key = path.shift();

    if (typeof object !== "object" || object === null) {
      return false;
    }

    if (path.length === 0) {
      return Object.hasOwnProperty.apply(object, [key]);
    } else {
      _x = object[key];
      _x2 = path;
      _again = true;
      continue _function;
    }
  }
};

//
// These arguments are the same as those for `exists`.
//
// The return value, however, is the property you're trying to access, or
// `undefined` if it can't be found. This means you won't be able to tell
// the difference between an unresolved path and an undefined property, so you
// should not use `get` to check for the existence of a property. Use `exists`
// instead.
//

var get = module.exports.get = function get(_x, _x2) {
  var _again = true;

  _function: while (_again) {
    _again = false;
    var object = _x,
        path = _x2;
    key = undefined;

    if (typeof path === "string") {
      path = path.split(".");
    }

    if (!(path instanceof Array) || path.length === 0) {
      return;
    }

    path = path.slice();

    var key = path.shift();

    if (typeof object !== "object" || object === null) {
      return;
    }

    if (path.length === 0) {
      return object[key];
    }

    if (path.length) {
      _x = object[key];
      _x2 = path;
      _again = true;
      continue _function;
    }
  }
};

//
// Arguments are similar to `exists` and `get`, with the exception that path
// components are regexes with some special cases. If a path component is `"*"`
// on its own, it'll be converted to `/.*/`.
//
// The return value is an array of values where the key path matches the
// specified criterion. If none match, an empty array will be returned.
//

var search = module.exports.search = function search(object, path) {
  if (typeof path === "string") {
    path = path.split(".");
  }

  if (!(path instanceof Array) || path.length === 0) {
    return;
  }

  path = path.slice();

  var key = path.shift();

  if (typeof object !== "object" || object === null) {
    return;
  }

  if (key === "*") {
    key = ".*";
  }

  if (typeof key === "string") {
    key = new RegExp(key);
  }

  if (path.length === 0) {
    return Object.keys(object).filter(key.test.bind(key)).map(function (k) {
      return object[k];
    });
  } else {
    return Array.prototype.concat.apply([], Object.keys(object).filter(key.test.bind(key)).map(function (k) {
      return search(object[k], path);
    }));
  }
};

//
// The first two arguments for `put` are the same as `exists` and `get`.
//
// The third argument is a value to `put` at the `path` of the `object`.
// Objects in the middle will be created if they don't exist, or added to if
// they do. If a value is encountered in the middle of the path that is *not*
// an object, it will not be overwritten.
//
// The return value is `true` in the case that the value was `put`
// successfully, or `false` otherwise.
//

var put = module.exports.put = function put(_x, _x2, _x3) {
  var _again = true;

  _function: while (_again) {
    _again = false;
    var object = _x,
        path = _x2,
        value = _x3;
    key = undefined;

    if (typeof path === "string") {
      path = path.split(".");
    }

    if (!(path instanceof Array) || path.length === 0) {
      return false;
    }

    path = path.slice();

    var key = path.shift();

    if (typeof object !== "object" || object === null) {
      return false;
    }

    if (path.length === 0) {
      object[key] = value;
    } else {
      if (typeof object[key] === "undefined") {
        object[key] = {};
      }

      if (typeof object[key] !== "object" || object[key] === null) {
        return false;
      }

      _x = object[key];
      _x2 = path;
      _x3 = value;
      _again = true;
      continue _function;
    }
  }
};

//
// `remove` is like `put` in reverse!
//
// The return value is `true` in the case that the value existed and was removed
// successfully, or `false` otherwise.
//

var remove = module.exports.remove = function remove(_x, _x2, _x3) {
  var _again = true;

  _function: while (_again) {
    _again = false;
    var object = _x,
        path = _x2,
        value = _x3;
    key = undefined;

    if (typeof path === "string") {
      path = path.split(".");
    }

    if (!(path instanceof Array) || path.length === 0) {
      return false;
    }

    path = path.slice();

    var key = path.shift();

    if (typeof object !== "object" || object === null) {
      return false;
    }

    if (path.length === 0) {
      if (!Object.hasOwnProperty.call(object, key)) {
        return false;
      }

      delete object[key];

      return true;
    } else {
      _x = object[key];
      _x2 = path;
      _x3 = value;
      _again = true;
      continue _function;
    }
  }
};

//
// `deepKeys` creates a list of all possible key paths for a given object.
//
// The return value is always an array, the members of which are paths in array
// format. If you want them in dot-notation format, do something like this:
//
// ```js
// dotty.deepKeys(obj).map(function(e) {
//   return e.join(".");
// });
// ```
//
// *Note: this will probably explode on recursive objects. Be careful.*
//

var deepKeys = module.exports.deepKeys = function deepKeys(object, options, prefix) {
  options = options || {};

  if (typeof prefix === "undefined") {
    prefix = [];
  }

  var keys = [];

  for (var k in object) {
    if (!Object.hasOwnProperty.call(object, k)) {
      continue;
    }

    if (!options.leavesOnly || typeof object[k] !== "object") {
      keys.push(prefix.concat([k]));
    }

    if (typeof object[k] === "object" && object[k] !== null) {
      keys = keys.concat(deepKeys(object[k], { leavesOnly: options.leavesOnly }, prefix.concat([k])));
    }
  }

  if (options.asStrings) {
    keys = keys.map(function (e) {
      return e.join(".");
    });
  }

  return keys;
};

},{}],35:[function(require,module,exports){
"use strict";

var app = require("../app");
var angular = (window.angular);

app.factory("enTable", enTable);

//@ngInject
function enTable(ngTableParams) {
  return function (Model) {
    var opts = arguments[1] === undefined ? {} : arguments[1];

    var table = new ngTableParams({
      page: 1,
      count: 25
    }, {
      total: 0,
      getData: function getData($defer, params) {
        var queryOpts = {
          _offset: (params.page() - 1) * params.count(),
          _limit: params.count(),
          _config: "meta-filter-count",
          _sort: params.orderBy().map(function (field) {
            return field.replace(/^\+/, "");
          }).join(","),
          _q: params.filter().query || null
        };

        if (opts.query) {
          queryOpts = angular.extend(queryOpts, opts.query);
        }

        Model.query(queryOpts, function (data, headers) {
          params.total(headers("Meta-Filter-Count"));
          $defer.resolve(data);
        });
      }
    });

    return table;
  };
}

},{"../app":8}],36:[function(require,module,exports){
"use strict";

var app = require("../app");

var objProto = Object.prototype;
var owns = objProto.hasOwnProperty;
var toStr = objProto.toString;
var NUMBER_STRING = /^\-?\d+$/;

var isActualNaN = function isActualNaN(value) {
  return value !== value;
};

var is = {

  number: function number(value) {
    return toStr.call(value) === "[object Number]";
  },

  integer: function integer(value) {
    return is.number(value) && !isActualNaN(value) && value % 1 === 0;
  },

  integerLike: function integerLike(value) {
    return is.integer(value) || is.string(value) && NUMBER_STRING.test(value);
  },

  string: function string(value) {
    return toStr.call(value) === "[object String]";
  },

  object: function object(value) {
    return toStr.call(value) === "[object Object]";
  }
};

is.id = is.integerLike;

app.value("is", is);

},{"../app":8}],37:[function(require,module,exports){
"use strict";

var app = require("../app");
var templateUrl = require("../helpers/templateUrl");

app.factory("questionModal", questionModal);
// @ngInject
function questionModal($modal) {
  return function (questionText) {
    return $modal.open({
      size: "sm",
      templateUrl: templateUrl("questionModal"),
      controller: "questionModalController",
      controllerAs: "Modal",
      resolve: {
        questionText: (function (_questionText) {
          var _questionTextWrapper = function questionText() {
            return _questionText.apply(this, arguments);
          };

          _questionTextWrapper.toString = function () {
            return _questionText.toString();
          };

          return _questionTextWrapper;
        })(function () {
          return questionText;
        })
      }
    }).result;
  };
}

app.controller("questionModalController", questionModalController);
// @ngInject
function questionModalController(questionText, $modalInstance) {
  this.question = questionText;
  this.yes = function () {
    return $modalInstance.close("OK");
  };
  this.no = function () {
    return $modalInstance.dismiss("NO");
  };
}

},{"../app":8,"../helpers/templateUrl":29}],38:[function(require,module,exports){
/// <reference path="../../../../typings/angularjs/angular-resource.d.ts" />

"use strict";

var app = require("../app.js");

app.factory("Resource", function ($resource) {
  return function (url, params, methods) {
    var defaults = {
      update: { method: "put", isArray: false },
      create: { method: "post" } };

    methods = angular.extend(defaults, methods);

    var resource = $resource(url, params, methods);

    resource.prototype.$save = function () {

      if (!this.id) {
        return this.$create();
      } else {
        return this.$update();
      }
    };

    return resource;
  };
});

app.factory("Customers",
/*@ngInject*/
function (Resource) {
  return Resource("/api/customers/:id", { id: "@id" });
});

app.factory("Assets",
/*@ngInject*/
function (Resource) {
  return Resource("/api/assets/:id", { id: "@id", _with: "customer,product.supplier,site" });
});

app.factory("Invoices",
/*@ngInject*/
function (Resource) {
  return Resource("/api/invoices/:id", { id: "@id" });
});

app.factory("InvoiceItems",
/*@ngInject*/
function (Resource) {
  return Resource("/api/invoice-items/:id", { id: "@id" });
});

app.factory("Products",
/*@ngInject*/
function (Resource) {
  return Resource("/api/products/:id", { id: "@id" });
});

app.factory("Suppliers",
/*@ngInject*/
function (Resource) {
  return Resource("/api/suppliers/:id", { id: "@id" });
});

app.factory("Sites",
/*@ngInject*/
function (Resource) {
  return Resource("/api/sites/:id", { id: "@id" });
});

app.factory("ProductPricing",
/*@ngInject*/
function (Resource) {
  return Resource("/api/product-pricing/:id", { id: "@id" });
});

app.factory("ServiceChanges",
/*@ngInject*/
function (Resource, $http) {
  var ServiceChange = Resource("/api/serviceChanges/:id", { id: "@id" });

  ServiceChange.prototype.canComplete = function () {
    return $http.get("/api/serviceChanges/" + this.id + "/cancomplete").then(function (response) {
      return response.data;
    });
  };

  ServiceChange.prototype.complete = function () {
    return $http.post("/api/serviceChanges/" + this.id + "/complete").then(function (response) {
      return response.data;
    });
  };

  return ServiceChange;
});

},{"../app.js":8}],39:[function(require,module,exports){
"use strict";

var app = require("../app");

app.directive("fileModel", ["$parse", function ($parse) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;
      element[0].addEventListener("change", function (e) {
        scope.$apply(function () {
          modelSetter(scope, e.target.files[0]);
        });
      });
    }
  };
}]).service("fileUpload", ["$http", function ($http) {
  this.uploadFileToUrl = function (file, data, uploadUrl) {
    if (!uploadUrl) {
      uploadUrl = data;
      data = null;
    }
    var fd = new FormData();

    if (data) {
      fd.append("data", angular.toJson(data));
    }

    fd.append("file", file);

    var promise = $http.post(uploadUrl, fd, {
      transformRequest: angular.identity,
      headers: { "Content-Type": undefined }
    });

    return promise
    // .success(function(){
    // })
    // .error(function(){
    // })
    ;
  };
}]);

},{"../app":8}],40:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

var AssetDetailsMini = (function () {
  function AssetDetailsMini(Assets) {
    _classCallCheck(this, AssetDetailsMini);

    this.AssetsModel = Assets;
    this.activate();
  }

  _createClass(AssetDetailsMini, {
    activate: {
      value: function activate() {
        if (this.isAssetBare()) this.populateAsset();
      }
    },
    isAssetBare: {
      value: function isAssetBare() {
        return true;
      }
    },
    populateAsset: {
      value: function populateAsset() {
        var _this = this;

        this.AssetsModel.get({ id: this.asset.id }).$promise.then(function (asset) {
          return _this.asset = asset;
        });
      }
    }
  });

  return AssetDetailsMini;
})();

component({
  name: "assetDetailMini",
  controller: AssetDetailsMini,
  bindToController: {
    asset: "=",
    title: "@"
  },
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\asset\\asset-detail-mini.js")
},{"./../../modules/componentMaker.js":48}],41:[function(require,module,exports){
(function (__filename){
"use strict";

var component = require('./../../modules/componentMaker.js');

/*
  component: assetHistoryItem
  selector: <asset-history-item></asset-history-item>
*/

component({
  name: "assetHistoryItem",
  scope: {
    icon: "=",
    item: "="
  },
  transclude: true,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\asset\\asset-history-item.js")
},{"./../../modules/componentMaker.js":48}],42:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

/*
  component: assetHistory
  selector: <asset-history></asset-history>
*/

var AssetHistory = (function () {
  function AssetHistory($scope, ServiceChanges, Assets, Products) {
    "ngInject";

    _classCallCheck(this, AssetHistory);

    Object.assign(this, { $scope: $scope, ServiceChanges: ServiceChanges, Assets: Assets, Products: Products });
    this.loadedAssets = new Set();
    this.loadedServiceChanges = new Set();
    this.historyItems = [];

    this.activate();
  }

  _createClass(AssetHistory, {
    activate: {
      value: function activate() {
        var _this = this;

        this.$scope.$watch("comp.asset.id", function (newId) {
          return _this.loadAssetHistory(newId);
        });
      }
    },
    loadAssetHistory: {
      value: function loadAssetHistory(assetId) {
        var _this = this;

        if (!assetId || this.loadedAssets.has(assetId)) {
          return;
        }

        this.Assets.get({ id: assetId, _with: "serviceChanges.assets" }).$promise.then(function (data) {
          _this.loadedAssets.add(assetId);
          _this.addServiceChanges(data.service_changes);
        });
      }
    },
    addServiceChanges: {
      value: function addServiceChanges(changes) {
        var _this = this;

        changes.filter(function (change) {
          return change.state === "completed";
        }).forEach(function (change) {
          return _this.addServiceChange(change);
        });
      }
    },
    addServiceChange: {
      value: function addServiceChange(change) {
        var _this = this;

        if (this.loadedServiceChanges.has(change.id)) {
          return;
        }
        this.loadedServiceChanges.add(change.id);

        var historyItem = {
          id: change.id,
          type: change.type,
          date: change.date_primary.substr(0, 10),
          onPrimaryAsset: false
        };

        var onPrimaryAsset = false;

        change.assets.forEach(function (asset) {
          historyItem[asset.pivot.role] = asset;

          if (asset.id == _this.asset.id) {
            historyItem.onPrimaryAsset = true;
          }

          _this.loadAssetHistory(asset.id);
        });

        if (historyItem.type == "migrateProvider") {
          historyItem.type = "migration";
          if (this.asset.id == historyItem.migratingFrom.id) {
            historyItem.relation = "from";
          } else if (this.asset.id == historyItem.migratingTo.id) {
            historyItem.relation = "to";
          }
        } else if (historyItem.type == "regrade") {
          this.Products.get({ id: change.meta.previous_product_id }).$promise.then(function (product) {
            return historyItem.previousProduct = product;
          });

          this.Products.get({ id: change.meta.regrade_product_id }).$promise.then(function (product) {
            return historyItem.regradeProduct = product;
          });
        }

        this.historyItems.push(historyItem);

        this.historyItems.sort(function (a, b) {
          return a.date > b.date ? 1 : a.date < b.date ? -1 : 0;
        });
      }
    }
  });

  return AssetHistory;
})();

component({
  name: "assetHistory",
  require: "asset",
  scope: {
    asset: "="
  },
  controller: AssetHistory,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\asset\\asset-history.js")
},{"./../../modules/componentMaker.js":48}],43:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

/*
  component: assetSelect
  selector: <asset-select></asset-select>
*/

var AssetSelect = (function () {
  function AssetSelect(Assets, assetModal) {
    "ngInject";

    _classCallCheck(this, AssetSelect);

    this.Assets = Assets;
    this.assetModal = assetModal;
  }

  _createClass(AssetSelect, {
    onSelectAsset: {
      value: function onSelectAsset(idObj) {
        var _this = this;

        console.log(idObj);
        this.Assets.get({
          id: idObj.id,
          _with: "customer,site,product.supplier"
        }).$promise.then(function (asset) {
          return _this.onSelect({ asset: asset });
        });
      }
    },
    openCreateModal: {
      value: function openCreateModal() {
        var _this = this;

        this.assetModal().then(function (asset) {
          return _this.onSelect({ asset: asset });
        });
      }
    },
    noop: {
      value: function noop() {}
    }
  });

  return AssetSelect;
})();

component({
  name: "assetSelect",
  scope: {
    onSelect: "&",
    title: "@"
  },
  controller: AssetSelect,
  controllerAs: "comp",
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\asset\\asset-select.js")
},{"./../../modules/componentMaker.js":48}],44:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

/*
  component: datePicker
  selector: <date-picker></date-picker>
*/

var DatePicker = (function () {
  function DatePicker() {
    "ngInject";

    _classCallCheck(this, DatePicker);

    this.activate();
  }

  _createClass(DatePicker, {
    activate: {
      value: function activate() {
        this.internalDate = this.date;
        this.editable = typeof this.editable === "undefined" ? true : this.editable;
      }
    },
    onInternalChange: {
      value: function onInternalChange() {
        this.date = this.formatDate(this.internalDate);
        this.datepickerOpen = false;
        this.onChange({ date: this.date });
      }
    },
    formatDate: {
      value: function formatDate(date) {
        if (!date) {
          return null;
        }
        if (date instanceof Date == false) {
          date = new Date(date);
        }

        if (date.toDateString() == "Invalid Date") {
          return null;
        }return "" + date.getFullYear() + "-" + leadingZero(date.getMonth() + 1) + "-" + leadingZero(date.getDate());

        function leadingZero(number) {
          return number < 10 ? "0" + number : number;
        }
      }
    }
  });

  return DatePicker;
})();

component({
  name: "datePicker",
  require: "date",
  scope: {
    date: "=",
    editable: "=",
    onChange: "&"
  },
  controller: DatePicker,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\datePicker\\datePicker.js")
},{"./../../modules/componentMaker.js":48}],45:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

/*
  component: productShowOrSelect
  selector: <product-show-or-select></product-show-or-select>
*/

var ProductShowOrSelect = (function () {
  function ProductShowOrSelect($scope) {
    "ngInject";

    _classCallCheck(this, ProductShowOrSelect);

    Object.assign(this, { $scope: $scope });

    this.activate();
  }

  _createClass(ProductShowOrSelect, {
    activate: {
      value: function activate() {
        if (!this.productId) this.startWatch();
      }
    },
    startWatch: {
      value: function startWatch() {
        var _this = this;

        if (this.isWatching) {
          return;
        }
        this.$scope.$watch("comp.selectProduct", function () {
          return _this.internalOnSelect();
        });
        this.isWatching = true;
      }
    },
    internalOnSelect: {
      value: function internalOnSelect() {
        if (!this.selectProduct) {
          return;
        }

        this.productId = this.selectProduct.id;
        this.onSelect({ productId: this.productId, product: this.selectProduct });
      }
    },
    clear: {
      value: function clear() {
        this.productId = this.selectProduct = null;
        this.onSelect({ productId: null, product: null });
        this.startWatch();
      }
    }
  });

  return ProductShowOrSelect;
})();

component({
  name: "productShowOrSelect",
  scope: {
    productId: "=",
    filter: "=",
    canClear: "=",
    onSelect: "&" },
  controller: ProductShowOrSelect,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\product\\product-show-or-select.js")
},{"./../../modules/componentMaker.js":48}],46:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

var serviceChangeDetailsCtrl = (function () {
  function serviceChangeDetailsCtrl(ServiceChanges, $state) {
    "ngInject";

    _classCallCheck(this, serviceChangeDetailsCtrl);

    this.ServiceChangeModel = ServiceChanges;
    this.$state = $state;
    this.activate();
  }

  _createClass(serviceChangeDetailsCtrl, {
    activate: {
      value: function activate() {
        this.updateIsStored();
        this.updateIsEditable();
        this.updateAssetsByRole();
        this.updateCanComplete();
        this.updateAssetRoles();
        this.setDate();
      }
    },
    updateIsStored: {
      value: function updateIsStored() {
        this.isStored = "id" in this.serviceChange;
      }
    },
    updateIsEditable: {
      value: function updateIsEditable() {
        this.editiable = ["completed", "canceled"].indexOf(this.serviceChange.state) == -1;
      }
    },
    updateAssetsByRole: {
      value: function updateAssetsByRole() {
        this.assetByRole = {};
        this.assets = [];

        if (!this.serviceChange.assets) {
          return;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.serviceChange.assets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var asset = _step.value;

            this.assetByRole[asset.pivot.role] = asset;
            this.assets.push({ id: asset.id, role: asset.pivot.role });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"]) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    updateCanComplete: {
      value: function updateCanComplete() {
        var _this = this;

        if (!this.isStored) {
          this.canComplete = false;
          this.completionErrors = { stored: ["Not saved yet"] };
          return;
        }

        if (!this.editiable) {
          this.canComplete = false;
        }

        this.serviceChange.canComplete().then(function (result) {
          _this.canComplete = result.passes;
          _this.completionErrors = result.errors;
        });
      }
    },
    updateAssetRoles: {
      value: function updateAssetRoles() {
        switch (this.serviceChange.type) {
          case "migrateProvider":
            this.assetRoles = ["migratingFrom", "migratingTo"];
            break;

          case "cease":
            this.assetRoles = ["ceasing"];
            break;

          case "regrade":
            this.assetRoles = ["regrading"];
            break;

          case "deployment":
            this.assetRoles = ["deploying"];
            break;
        }
      }
    },
    setDate: {
      value: function setDate() {
        // this.isDirty = true;
        this.serviceChange.date_primary = this.formatDate(this.serviceChange.date_primary);
        if (this.catchedDate !== undefined && this.serviceChange.date_primary !== this.catchedDate) {
          this.isDirty = true;
        }
        this.catchedDate = this.serviceChange.date_primary;
      }
    },
    setAsset: {
      value: function setAsset(asset, role) {
        this.isDirty = true;
        this.assetByRole[role] = asset;
        this.assets.push({ id: asset.id, role: role });
      }
    },
    setMeta: {
      value: function setMeta(key, value) {
        this.meta = this.meta || {};

        if (this.meta[key] !== value) {
          this.isDirty = true;
        }

        if (value === null) {
          delete this.meta[key];
          return;
        }

        this.meta[key] = value;
      }
    },
    save: {
      value: function save() {
        var _this = this;

        var serviceChange = this.serviceChange;
        serviceChange.assets = this.assets;

        this.loading = true;
        this.isDirty = false;

        var redirectOnSave = !this.isStored;

        serviceChange.$save().then(function () {
          _this.loading = false;
          if (redirectOnSave && serviceChange.id) {
            _this.$state.go("serviceChangeDetails", { servicechangeId: serviceChange.id });
          } else {
            _this.reload();
          }
        });
      }
    },
    complete: {
      value: function complete() {
        var _this = this;

        this.loading = true;
        this.serviceChange.complete().then(function () {
          _this.loading = false;
          _this.reload();
        });
      }
    },
    reload: {
      value: function reload() {
        var _this = this;

        this.loading = true;
        this.ServiceChangeModel.get({ id: this.serviceChange.id }).$promise.then(function (result) {
          _this.serviceChange = result;
          _this.activate();
          _this.loading = false;
        });
      }
    },
    formatDate: {
      value: function formatDate(date) {
        if (!date) {
          return null;
        }
        if (date instanceof Date == false) {
          date = new Date(date);
        }

        if (date.toDateString() == "Invalid Date") {
          return null;
        }return "" + date.getFullYear() + "-" + leadingZero(date.getMonth() + 1) + "-" + leadingZero(date.getDate());

        function leadingZero(number) {
          return number < 10 ? "0" + number : number;
        }
      }
    }
  });

  return serviceChangeDetailsCtrl;
})();

component({
  name: "serviceChangeDetails",
  required: "serviceChange",
  scope: {
    serviceChange: "="
  },
  controller: serviceChangeDetailsCtrl,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\servicechange\\servicechange-details.js")
},{"./../../modules/componentMaker.js":48}],47:[function(require,module,exports){
(function (__filename){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var component = require('./../../modules/componentMaker.js');

var _require = (window.angular);

var copy = _require.copy;
var extend = _require.extend;
var equals = _require.equals;

var debounce = require("lodash/function/debounce");

/*
  component: servicechangeFilter
  selector: <servicechange-filter></servicechange-filter>
*/

var ServicechangeFilter = (function () {
  function ServicechangeFilter($scope) {
    "ngInject";

    _classCallCheck(this, ServicechangeFilter);

    extend(this, { $scope: $scope });
    this.activate();
  }

  _createClass(ServicechangeFilter, {
    activate: {
      value: function activate() {
        var _this = this;

        this.$scope.$watch("comp.extFilter", function (filterValue) {
          return _this.filter = copy(filterValue);
        }, true);
        this.$scope.$watch("comp.filter", function (val) {
          return _this.update(val);
        }, true);

        this.types = [{ value: "migrateProvider", label: "Migrate Provider" }, { value: "cease", label: "Cease" }, { value: "regrade", label: "Regrade" }, { value: "deployment", label: "Deployment" }];

        this.states = [{ value: 0, label: "Pending" }, { value: 128, label: "Completed" }];
      }
    },
    update: {
      value: function update(filterValue) {
        if (equals(filterValue, this.extFilter)) {
          return;
        }
        this.extFilter = copy(filterValue);

        if (this.onChange) {
          this.onChange({ filter: this.extFilter });
        }
      }
    }
  });

  return ServicechangeFilter;
})();

component({
  name: "servicechangeFilter",
  require: "filter",
  scope: {
    show: "=",
    extFilter: "=filter",
    onChange: "&"
  },
  controller: ServicechangeFilter,
  templateUrl: component.extToHtml(__filename)
});

}).call(this,"/resources\\client\\components\\servicechange\\servicechange-filter.js")
},{"./../../modules/componentMaker.js":48,"lodash/function/debounce":2}],48:[function(require,module,exports){
"use strict";

var angular = (window.angular);
var app = require('./../../assets/js/app.js');

function component(name, options) {
  if (angular.isObject(name)) {
    options = name;
    name = options.name;
    delete options.name;
  } else {
    options = name;
  }

  var controllerAs = options.controllerAs;

  options = angular.extend({
    restrict: "E",
    scope: {},
    controller: function controller() {},
    controllerAs: "comp",
    bindToController: true
  }, options);

  if (controllerAs === false) {
    delete options.controllerAs;
  }

  app.directive(name, function () {
    return options;
  });
}

component.extToHtml = function extToHtml(path) {
  return path.replace(/^.*components/, "components").replace(/\.\w+$/, "") + ".html";
};

module.exports = component;

},{"./../../assets/js/app.js":8}],49:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var app = require('./../../assets/js/app.js');
var angular = (window.angular);

var ServiceChangeHelper = (function () {
  function ServiceChangeHelper($state, ServiceChanges) {
    "ngInject";

    _classCallCheck(this, ServiceChangeHelper);

    angular.extend(this, { $state: $state, ServiceChanges: ServiceChanges });
  }

  _createClass(ServiceChangeHelper, {
    newServiceChange: {
      value: function newServiceChange() {
        var serviceChange = new this.ServiceChanges();
        serviceChange.assets = [];
        serviceChange.state = "pending";

        return serviceChange;
      }
    },
    startCease: {
      value: function startCease(options) {
        var serviceChange = this.newServiceChange();

        serviceChange.type = "cease";

        if (options.ceaseAssetId) {
          this.assignRole(serviceChange, "ceasing", options.ceaseAssetId);
        }

        this.$state.go("serviceChangeCreate", { options: { serviceChange: serviceChange } });
      }
    },
    startMigration: {
      value: function startMigration(options) {
        var serviceChange = this.newServiceChange();

        serviceChange.type = "migrateProvider";

        if (options.fromAssetId) {
          this.assignRole(serviceChange, "migratingFrom", options.fromAssetId);
        }

        if (options.toAssetId) {
          this.assignRole(serviceChange, "migratingTo", options.toAssetId);
        }

        this.$state.go("serviceChangeCreate", { options: { serviceChange: serviceChange } });
      }
    },
    startRegrade: {
      value: function startRegrade(options) {
        var serviceChange = this.newServiceChange();

        serviceChange.type = "regrade";

        if (options.regradeAssetId) {
          this.assignRole(serviceChange, "regrading", options.regradeAssetId);
        }

        if (options.previousProductId) {
          serviceChange.meta = { previous_product_id: options.previousProductId };
        }

        this.$state.go("serviceChangeCreate", { options: { serviceChange: serviceChange } });
      }
    },
    assignRole: {
      value: function assignRole(serviceChange, role, assetOrId) {
        var asset = undefined;
        if (typeof assetOrId == "string" || typeof assetOrId == "number") {
          asset = {
            id: assetOrId
          };
        } else {
          asset = angular.copy(assetOrId);
        }

        asset.pivot = { role: role };

        serviceChange.assets.push(asset);
      }
    }
  });

  return ServiceChangeHelper;
})();

app.service("ServiceChangeHelper", ServiceChangeHelper);

},{"./../../assets/js/app.js":8}]},{},[30]);
